import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withKeys as _withKeys, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full text-gray-darker py-2" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "mb-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hideHeader && _ctx.notes.length && !_ctx.hidePatient)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.patientName), 1))
      : _createCommentVNode("", true),
    (!_ctx.hideHeader && _ctx.notes.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(`${_ctx.headerRoomName} ${_ctx.treatmentFullName} ${_ctx.treatmentNameComputed ? `(${_ctx.treatmentNameComputed})` : ''}`), 1))
      : _createCommentVNode("", true),
    (_ctx.editedNotes.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.editedNotes, (note, i) => {
          return (_openBlock(), _createBlock(_component_v_text_field, {
            ref_for: true,
            ref: `${_ctx.patientName}_note_input_${i}`,
            key: `note.-.${note.uuid}.-.${i}`,
            class: "mb-4",
            hint: `${_ctx.$dayjs(note.created_at).format('MMM D, YYYY hh:mm A')}`,
            label: `Note of ${!!note.user ? note.user.name : 'Deleted user'}`,
            "append-inner-icon": !!note.user && _ctx.currentUser === note.user.uuid && !note.new ? 'mdi-checkbox-marked-circle-outline' : undefined,
            "append-icon": !!note.user && _ctx.currentUser === note.user.uuid && !note.new ? 'mdi-delete' : undefined,
            readonly: !!note.user && _ctx.currentUser !== note.user.uuid || note.new,
            "persistent-hint": "",
            modelValue: _ctx.editedNotes[i].message,
            "onUpdate:modelValue": ($event: any) => ((_ctx.editedNotes[i].message) = $event),
            variant: "outlined",
            density: "compact",
            "onClick:appendInner": ($event: any) => (_ctx.editTreatmentNote(i)),
            "onClick:append": ($event: any) => (_ctx.deleteTreatmentNote(i)),
            onKeydown: _withKeys(($event: any) => {_ctx.editTreatmentNote(i);}, ["enter"]),
            onClick: ($event: any) => (_ctx.handleFocusedInput(`note.-.${note.uuid}.-.${i}`, _ctx.editedNotes[i]?.message)),
            onBlur: ($event: any) => (_ctx.checkIsSaved(i))
          }, null, 8, ["hint", "label", "append-inner-icon", "append-icon", "readonly", "modelValue", "onUpdate:modelValue", "onClick:appendInner", "onClick:append", "onKeydown", "onClick", "onBlur"]))
        }), 128))
      : _createCommentVNode("", true),
    _createVNode(_component_v_btn, {
      variant: "plain",
      disabled: _ctx.adding,
      class: "mb-4 pl-0",
      color: "grey-lighten-500",
      onClick: _ctx.newNoteFocus
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Add Note " + _toDisplayString(_ctx.treatmentNameComputed ? `in ${_ctx.treatmentNameComputed}` : '') + " + ", 1)
      ]),
      _: 1
    }, 8, ["disabled", "onClick"]),
    (_ctx.adding)
      ? (_openBlock(), _createBlock(_component_v_text_field, {
          ref: "new-note",
          "append-inner-icon": "mdi-checkbox-marked-circle-outline",
          "append-icon": "mdi-delete",
          key: "note-treatmentDialogAdd",
          class: _normalizeClass({'mb-4': !_ctx.hideHeader }),
          color: _ctx.error ? 'red' : undefined,
          hint: _ctx.hint,
          label: "Add a note",
          modelValue: _ctx.newNote,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newNote) = $event)),
          variant: "outlined",
          density: "compact",
          "persistent-hint": _ctx.error,
          "onClick:appendInner": _cache[1] || (_cache[1] = ($event: any) => (_ctx.createNote($event))),
          "onClick:append": _ctx.toggleOffAddingNote,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleFocusedInput(`note-treatmentDialogAdd`, _ctx.newNote))),
          onBlur: _ctx.checkIsSavedNewNote
        }, null, 8, ["class", "color", "hint", "modelValue", "persistent-hint", "onClick:append", "onBlur"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.confirmDeleteOpen,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirmDeleteOpen) = $event)),
      "max-width": "420"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h6" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Delete note?", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("Are you sure you want to delete this note? This cannot be undone.", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _ctx.cancelDeleteNote
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("Cancel", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  color: "error",
                  variant: "flat",
                  onClick: _ctx.confirmDeleteNote
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("Delete", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}